<template>
<div class="wangEditor">
    <div :id="editorId" style="text-align:left;height:100%"></div>
</div>
</template>

<script>
import E from 'wangeditor'
import { aliyunUpload } from '@/api/saas/package'
import { getToken } from '@/utils/auth'

export default {
    name: 'editor',
    props: {
        editorId: { // 初始化id值
            type: String|Number,
            required: true
        },
        contenteditable: { // 是否可编辑
            type: Boolean,
            default: true
        },
        editorContent: { // 初始化值
            type: String,
            default: ''
        },
        isChange: { // 内容是否在父级由代码赋值改变(父级赋值改变内容的操作时必传)
            type: Boolean
        },
        menuString: { // 菜单初始化
            type: Array,
            default: () => [
                'head', // 标题
                'bold', // 粗体
                'fontSize', // 字号
                'fontName', // 字体
                'lineHeight', // 行高
                'italic', // 斜体
                'underline', // 下划线
                'strikeThrough', // 删除线
                'foreColor', // 文字颜色
                'backColor', // 背景颜色
                'link', // 插入链接
                'list', // 列表
                'justify', // 对齐方式
                'quote', // 引用
                'emoticon', // 表情
                'image', // 插入图片
                'table', // 表格
                'video', // 插入视频
                'code', // 插入代码
                'undo', // 撤销
                'redo', // 重复
                'preview', // 预览
            ]
        },
        poiId: { // 景点id
            default: ''
        }
    },
    data () {
        return {
            eidtor: '',
            data: {},
            fileName: '',
        }
    },
    methods: {
        // 上传图片
        aliyunUpload (formData, index) {
            return new Promise((resolve, reject) => {
                aliyunUpload(formData).then((res)=>{
                    const url = res.url
                    resolve(url)
                }).catch(error => {
                })

            })
        }
    },
    mounted () {
        let idString = '#' + this.editorId
        const editor = new E(document.getElementById(this.editorId))
        editor.config.menus = this.menuString
        editor.config.zIndex = 8
        // 设置编辑区域高度为 400px
        editor.config.height = 400
        editor.config.lineHeights = ['1', '1.15', '1.6', '2', '2.5', '3']
        editor.config.showFullScreen = false // 是否显示全屏按钮
        editor.config.uploadVideoMaxSize = 1 * 1024 * 1024 * 500 // 限制视频大小 // 1024m
        editor.config.uploadVideoAccept = ['mp4', 'MOV', 'avi'] // 限制视频类型
        editor.config.onchange = (html) => {
            this.$emit('input', html)
            this.$emit('aiChange', html)
        }
        editor.config.customUploadImg = (files, insert) => {
            files.sort((prev, next) => {
                return prev.name.localeCompare(next.name)
            })
            if (files.length) {
                const uploadP = files.map((file, index) => {
                    // 文件上传
                    let formData = new FormData()
                    formData.append('file', file)
                    // 文件上传
                    return this.aliyunUpload(formData, index)
                })
                Promise.all(uploadP).then((result) => {
                    result.forEach(url => {
                        insert(url)
                    })
                }).catch((error) => {
                    console.log(error)
                })
            }
        }
        editor.config.customUploadVideo = (files, insert) =>{
            // files 是 input 中选中的文件列表
            // insert 是获取视频 url 后，插入到编辑器的方法
            files.sort((prev, next) => {
                return prev.name.localeCompare(next.name)
            })
            if (files.length) {
                const uploadP = files.map((file, index) => {
                    // 文件上传
                    let formData = new FormData()
                    formData.append('file', file)
                    // 文件上传
                    return this.aliyunUpload(formData, index)
                })
                Promise.all(uploadP).then((result) => {
                    result.forEach(url => {
                        // 上传视频，返回结果，将视频地址插入到编辑器中
                        insert(url)
                    })
                }).catch((error) => {
                    console.log(error)
                })
            }
        }
        editor.config.uploadImgParams = { // 自定义图片上传参数
            Authorization: getToken(),
        }
        editor.config.uploadVideoParams = { // 自定义图片上传参数
            Authorization: getToken(),
        }
        editor.config.uploadImgHeaders = {
            'Terminal-Type': 'PC',
            platform: 'pc'
        }
        editor.config.uploadVideoHeaders = {
            'Terminal-Type': 'PC',
            platform: 'pc'
        }
        editor.config.uploadImgServer = process.env.VUE_APP_BASE_API + "/upload/" // 上传图片到服务器
        editor.config.uploadVideoServer = process.env.VUE_APP_BASE_API + "/upload/" // 上传视频到服务器
        editor.create()
        this.editor = editor
        editor.txt.html(this.editorContent)
        editor.$textElem.attr('contenteditable', this.contenteditable)
    },
    beforeDestroy() {
        // 销毁编辑器
        this.editor.destroy()
        this.editor = null
    },
    watch: {
        editorContent (val) { // 设置富文本默认展示
            // this.editor.txt.html(this.editorContent)
            // this.editor.txt.html(this.editorContent)
        },
        contenteditable (val) { // 设置富文本是否可编辑
            editor.$textElem.attr('contenteditable', this.contenteditable)
        }
    }
}
</script>

<style lang="scss">
.wangEditor {
    img {
        margin: 10px 30px;
    }
}
.ivu-form-item-error{
    .wangEditor {
        .w-e-toolbar{
            border: 1px solid #ed3f14 !important;
        }
        .w-e-text-container{
            border: 1px solid #ed3f14 !important;
            border-top: none !important;
        }
    }
}
</style>
